import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { UserMgmtService } from "../user-management.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-view-user-lesson',
  templateUrl: './view-user-lesson.component.html',
  styleUrls: ['./view-user-lesson.component.css']
})
export class ViewUserLessonComponent implements OnInit {
  closeResult: string;
  userDetails: object;

  userLessonList = [];
  userId: any;
  courseId: any;
  private modalRef: NgbModalRef;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false
  };

  searchText: string = "";
  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private userMgmtService: UserMgmtService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) { }
  ngOnInit() {
    this.userId = this.route.snapshot.params["userId"];

    this.route.queryParams.subscribe(param => {
      this.courseId = param['courseId'];
    });
    this.getUserLesson(this.userId);
  }

  getUserLesson(userId) {
    let query = this.courseId + "?userId=" + userId;
    this.spinner.show();
    this.userMgmtService.getUserLesson(query).subscribe(res => {

      if ((res["message"] == "Success")) {
        this.userLessonList = res.data.asrUserResponseList;
        this.spinner.hide();

      } else {
        this.spinner.hide();
        this.userLessonList = [];
      }
    });
  }


}
